import { Component, Input, OnInit, ViewChild, Output, EventEmitter }  from '@angular/core';
import { Inject, Injectable } from '@angular/core';

import {DataSource} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import { Subject }  from 'rxjs/Subject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';

import { FireDataService } from '../fire-data.service';
import { CaseData } from '../case-data';

@Component({
  selector: 'app-case-grid',
  templateUrl: './case-grid.component.html',
  styleUrls: ['./case-grid.component.css']
})
export class CaseGridComponent implements OnInit {
    @Input() selectedCase
    @Output()
    childClick: EventEmitter<String> = new EventEmitter<String>();

  displayedColumns = ['regDate','caseId', 'firstTeacher', 'startDate', 'endDate','settled', 'classes', 'note'];
  dataSource: CaseDatabaseSource | null;
  caseDatabase = new CaseDatabase(this.fds);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public dataLength: any; // For member counter on DOM.

  constructor(private fds: FireDataService) { }

  ngOnInit() {
    this.fds.getCaseData(this.selectedCase.id)
    .subscribe(res => {
        this.dataSource = new CaseDatabaseSource(this.caseDatabase, this.paginator);
        this.dataLength = res.length;
    });
  }

  handleRowClick(row) {
    this.sendDataToParent(row)
  }

  sendDataToParent(data) {
    console.log("CASE-GRID --> send to case-master...:", data)
    this.childClick.emit(data)
  }
}

  @Injectable()
  //----------------------------------------------------------------
  // CaseDatabase class: prepare data for cdk-table datasource and 
  // change row management
  //----------------------------------------------------------------
  export class CaseDatabase {
  
      /* Stream that emits whenever the data has been modified. */
      public dataChange: BehaviorSubject<any> = new BehaviorSubject<CaseData[]>([]);
      get data(): CaseData[] {
          return this.dataChange.value; }
  
      // Connection to remote db.
  
      constructor(private fds: FireDataService) {
          this.fds.caseData
              .subscribe(data => this.dataChange.next(data));
      }
  }
   
  @Injectable()
  //----------------------------------------------------------------
  // CaseDatabase class: prepare data for cdk-table datasource and 
  // change row management
  //----------------------------------------------------------------
  export class CaseDatabaseSource extends DataSource<CaseData> {
  
  
      constructor(
          private caseDatabase: CaseDatabase,
          private paginator: MatPaginator) {
          super();
      }
  
  
      /** Connect function called by the table to retrieve one stream containing the data to render. */
      connect(): Observable<CaseData[]> {
  
        const displayDataChanges = [
            this.caseDatabase.dataChange,
            this.paginator.page,
        ];
  
        return Observable
            .merge(...displayDataChanges) // Convert object to array with spread syntax.
            .map(() => {
                const dataSlice = this.caseDatabase.data.slice(); // Data removed from viewed page.
  
                // Get the page's slice per pageSize setting.
                const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
  
                const dataLength = this.paginator.length;  // This is for the counter on the DOM.
  
                return dataSlice.splice(startIndex, this.paginator.pageSize);
            });
      }
      disconnect() {}
  }




// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-grid/case-grid.component.ts